import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { SignActionArgs } from '../../../services/commands/types';
import { AppState } from '../../../store/reducers/root';
import {
  getAllowedDSMediaTypes,
  getAvailableDSAgents,
  getAvailableDSKeyTypes,
  getForbiddenDSMediaTypes,
  getSignAlgo,
  getSignFormState,
} from '../../../store/selectors/session';
import commands from '../../../store/slices/commands';
import form from '../../../store/slices/form';
import session from '../../../store/slices/session';

import { SignForm } from './SignForm';

type SignFormOwnProps = {
  className?: string;
};

const mapStateToProps = (state: AppState, { className }: SignFormOwnProps) => {
  const signFormProps = getSignFormState(state);

  return {
    className,
    signFormProps,
    dsAgents: getAvailableDSAgents(state),
    dsKeyTypes: getAvailableDSKeyTypes(state),
    allowedDSMediaTypes: getAllowedDSMediaTypes(state),
    forbiddenDSMediaTypes: getForbiddenDSMediaTypes(state),
    signAlgo: getSignAlgo(state),
  };
};

const mapDispatchToProps = {
  onCloseSignForm: session.closeSignForm,
  onSignFailure: form.signFailure,
  onExecuteCommand: commands.execute,
};

const mergeProps = (
  { signFormProps, ...msp }: ReturnType<typeof mapStateToProps>,
  {
    onExecuteCommand,
    onCloseSignForm,
    onSignFailure,
  }: typeof mapDispatchToProps
) => ({
  ...msp,
  ...signFormProps,
  onClose: (_open: boolean) => {
    onCloseSignForm();
  },
  onError: (err: Error) => {
    onSignFailure(err);
  },
  onSign: (args: SignActionArgs) => {
    if (signFormProps?.datasetId) {
      onExecuteCommand({
        datasetId: signFormProps.datasetId,
        command: signFormProps.command,
        args,
      });
    }
  },
});
const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type SignFormContainerProps = ConnectedProps<typeof connector>;

export default connector(SignForm);
